// One DNS label: letters, digits and inner hyphens.
const LABEL = "[a-z0-9]([a-z0-9-]*[a-z0-9])?";

// `https://`, a name under looker.app and an optional trailing slash, and
// nothing else: no port, path, query, fragment, userinfo, whitespace or quote.
// Looker (Google Cloud core) names every instance under looker.app, and the
// connector sends the Admin key only there. The URL also reaches the Looker
// MCP Toolbox inside a single-quoted string in its YAML config, so any other
// character could add to that config.
const BASE_URL_PATTERN = new RegExp(
  `^https://${LABEL}(\\.${LABEL})*\\.looker\\.app/?$`,
  "i"
);

export const INSTANCE_URL_HINT =
  "Enter the instance's base URL with no path, such as " +
  "https://example.looker.app. P0 doesn't support custom domains or ports yet.";

/** The base URL of a Looker (Google Cloud core) instance, in lowercase and
 * without a trailing slash, or `undefined` if `instanceUrl` isn't
 * `https://<name>.looker.app` with an optional trailing slash.
 */
export const toLookerBaseUrl = (instanceUrl: string): string | undefined =>
  BASE_URL_PATTERN.test(instanceUrl)
    ? instanceUrl.replace(/\/$/, "").toLowerCase()
    : undefined;
